import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Duolingo-style button: the visible surface is rendered via the
 * `::before` pseudo-element, so the root button stays transparent and state
 * transitions never trigger layout reflow.
 */
export function Button({ variant = 'primary', size = 'md', uppercase = true, leading, trailing, className, children, ...rest }) {
    const cls = [
        'sl-btn',
        `sl-btn--${variant}`,
        `sl-btn--${size}`,
        uppercase ? 'sl-btn--upper' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { type: "button", className: cls, ...rest, children: [leading ? _jsx("span", { className: "sl-btn__icon sl-btn__icon--leading", children: leading }) : null, _jsx("span", { className: "sl-btn__label", children: children }), trailing ? _jsx("span", { className: "sl-btn__icon sl-btn__icon--trailing", children: trailing }) : null] }));
}
//# sourceMappingURL=Button.js.map